




<div class="container " style="margin-top:10px" *ngIf="isLoaded">


  <h2 class="heading-line">Comprehensive Product Information</h2>


  <section class="product-area product-single-area mt-3">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="product-single-item">
            <div class="row">
              <div class="col-xl-6">
                <!--== Start Product Thumbnail Area ==-->
          <img (click)="openSlideShow()" style="height:80%; width:100%; margin-right: 12px;"
            src="{{GetProductImage(ItemDetails.productImage[0].imagepath)}}" alt="">
          
          
          
          <div>
            <span>
              <img *ngFor="let image of ItemDetails.productImage"
                style="height:75px; width:75px; margin-right: 12px; margin-top: 12px;" src="{{GetProductImage(image.imagepath)}}"
                alt="" />
            </span>
          </div>
          <br />
          <div>
            <!-- <button (click)="AddToCartGlobal(ItemDetails.productId,ItemDetails, 'products-slider-', 1)"
                    class="btn btn-sm btn-light"><i class="material-icons left">shopping_cart</i> Add To
                    cart</button>
                  <button (click)="AddTowishlist(ItemDetails.productId, ItemDetails)" class="btn btn-sm btn-light"><i
                      class="material-icons left">favorite_border</i>
                    Save for later</button> -->
          </div>

                <!--== End Product Thumbnail Area ==-->
              </div>
              <div class="col-xl-6">
                <!--== Start Product Info Area ==-->
                <div class="product-single-info">
                  <h3 class="main-title">{{ItemDetails.productName}}</h3>
                  <div class="prices">
                    <span class="price">₹ {{ItemDetails.productprice*(ItemDetails.selectedQuantity==0?1:ItemDetails.selectedQuantity) }}</span>
                  </div>
                  <div class="rating-box-wrap">
                    <div class="rating-box">
                      <i class="fa fa-star"></i>
                      <i class="fa fa-star"></i>
                      <i class="fa fa-star"></i>
                      <i class="fa fa-star"></i>
                      <i class="fa fa-star"></i>
                    </div>
                    <div class="review-status">
                      <a href="javascript:void(0)">(5 Customer Review)</a>
                    </div>
                  </div>
                  <p>{{ItemDetails.productDesc}}</p>
               


                 
                  <div *ngFor="let attr of ItemDetails.productAttrubutes" class="product-size">
                    <h6 class="title">{{attr.attrName}}</h6>
                    <ul class="size-list">
                      <li>{{attr.attrvalue}}</li>
                   
                    </ul>
                  </div>
                  <div class="product-quick-action">
                  <div class="input-group input-group-sm input-spinner">
                    <div class="input-group-prepend">
                      <button class="btn btn-sm btn-light" (click)="updateCart('plus',ItemDetails)" type="button" id="button-plus">
                        <i class="fa fa-plus"></i>
                      </button>
                    </div>
                    <!-- <input type="text" class="form-control" readonly name="value" placeholder="{{item.selectedQuantity}}"
                            [(ngModel)]="item.selectedQuantity"> -->
                    <p style="margin-right: 14px; padding-top: 10px;"><b>{{ItemDetails.selectedQuantity}}</b></p>
                    <div class="input-group-append">
                      <button class="btn btn-sm btn-light" (click)="updateCart('minus',ItemDetails)" type="button" id="button-minus"> <i
                          class="fa fa-minus"></i>
                      </button>
                    </div>
                  </div>
                    <a class="btn-theme" (click)="addToCart(ItemDetails)">Add to Cart</a>
                  </div>
              
                </div>
                <!--== End Product Info Area ==-->
              </div>
            </div>
          </div>
        </div>
      </div>
  
     
    </div>
  </section>



  <app-photo-swipe #photoSwipe></app-photo-swipe>
  <div class="row d-none">


    <div class="col-12 col-sm-6">
      <h5 style="font-size: 20px;"> {{ItemDetails.productName}}</h5>
      <p> <b> ₹ {{ItemDetails.productprice*(ItemDetails.selectedQuantity==0?1:ItemDetails.selectedQuantity) }} </b></p>
      <p><b>Description</b></p>
      <p> {{ItemDetails.productDesc}}</p>
      <p><b>Other Info</b></p>

      <p *ngFor="let attr of ItemDetails.productAttrubutes">
        <b>{{attr.attrName}}</b> : {{attr.attrvalue}}
      </p>
      <!-- <p *ngIf="item.Color!='-' || item.Color!=''">
        color: {{item.Color}}
      </p>
      <p *ngIf="item.Brand!='-' || item.Brand!=''">
        Brand: {{item.Brand}}
      </p> -->

      <div class="input-group input-group-sm input-spinner">
        <div class="input-group-prepend">
          <button class="btn btn-sm btn-light" (click)="updateCart('plus',ItemDetails)" type="button" id="button-plus">
            <i class="fa fa-plus"></i>
          </button>
        </div>
        <!-- <input type="text" class="form-control" readonly name="value" placeholder="{{item.selectedQuantity}}"
          [(ngModel)]="item.selectedQuantity"> -->
        <p style="margin-right: 14px; padding-top: 10px;"><b>{{ItemDetails.selectedQuantity}}</b></p>
        <div class="input-group-append">
          <button class="btn btn-sm btn-light" (click)="updateCart('minus',ItemDetails)" type="button"
            id="button-minus"> <i class="fa fa-minus"></i>
          </button>
        </div>
      </div>


      <hr>
      <!-- <button class="btn btn-sm btn-light">Buy Now</button> -->
      <button (click)="addToCart(ItemDetails)" class="btn btn-sm btn-light"><i class="fa fa-shopping-cart"></i> Add To
        cart</button>
      <!-- <button (click)="AddTowishlist(allProductDetailNewWithAttr[0].ProductVersionId, allProductDetailNewWithAttr[0])"
        class="btn hvr-shutter-out-horizontal"><i class="material-icons left">favorite_border</i>
        Save for later</button> -->

    </div>
  </div>



    
    
    <app-cat-carousel></app-cat-carousel>


</div>





<!-- <app-footer></app-footer> -->